import React from "react";
import { useTranslation } from "react-i18next";

import { I18N_NAMESPACES } from "../../../helpers/constants";
import ModalContainer from "../ModalContainer";
import ShippingDatesNotice from "../../atoms/ShippingDatesNotice";

interface ShippingDatesNoticeModalProps {
  isOpened: boolean;
  onClose: () => void;
}

const ShippingDatesNoticeModal = ({ isOpened, onClose }: ShippingDatesNoticeModalProps) => {
  // Hook lives here, not in Layout, so the gifts namespace only loads when the
  // modal actually mounts (rare user action). See home-perf-followups.md Phase 1.
  const { t } = useTranslation([I18N_NAMESPACES.GIFTS]);

  return (
    <ModalContainer
      isOpened={isOpened}
      outsideClickHandler={onClose}
      title={t("gifts:shippingDatesModalTitle.true")}
      isScrollLockEnabled={isOpened}
    >
      <ShippingDatesNotice />
    </ModalContainer>
  );
};

export default ShippingDatesNoticeModal;
